"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("@opentelemetry/api");
var _OtelContext = require("../OtelContext");
var tracer = _api.trace.getTracer('phoenix-lib');
function withSpan(name) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fn = arguments.length > 2 ? arguments[2] : undefined;
  var activeContext = (0, _OtelContext.getTraceContextFromCookie)() || _api.ROOT_CONTEXT;
  _api.context.with(activeContext, function () {
    tracer.startActiveSpan(name, {
      attributes: attributes
    }, function (span) {
      try {
        if (typeof fn === 'function') {
          fn(span);
        }
      } catch (error) {
        span.recordException(error);
        span.setStatus({
          code: 2,
          message: (error === null || error === void 0 ? void 0 : error.message) || 'Interaction failed'
        });
      } finally {
        span.end();
      }
    });
  });
}
var _default = withSpan;
exports.default = _default;